<h5 class="mb-4">{{ "More from this user" }}</h5>

<astrobin-marketplace-listing-cards [listings]="otherListings"></astrobin-marketplace-listing-cards>
